import {ConversionApiEventType, ConversionCustomerType} from '@kidslabs/mario-client-event-tracking';

export enum MetaEventList {
    VIEW_CONTENT = 'ViewContent',
    VIEW_CATEGORY = 'ViewCategory',
    PAGE_VIEW = 'PageView',
    SEARCH = 'Search',
    ADD_TO_CART = 'AddToCart',
    PURCHASE = 'Purchase',
    INITIATE_CHECKOUT = 'InitiateCheckout',
    REGISTRATION = 'CompleteRegistration',
}

export interface EventTrackingConversionApi {
    custom_event: any;
    user_data: ConversionCustomerType;
    event_name: MetaEventList;
}

export interface ConversionCustomData {
    content_ids?: string[];
    content_category?: string;
    content_name?: string;
    content_type?: string;
    num_items?: string;
    currency?: string; //
    value?: number;
    contents?: ConversionCart[];
    order_id?: string;
    search_string?: string;
    status?: string;
    //delivery_category?: string; //"in_store", "home_delivery" hoặc "curbside"
    registration_method?: string;
    custom_properties?: {
        page_view?: string;
        cart_id?: string;
        page_title?: string;
        page_url?: string;
    };
}

export interface ConversionCart {
    id?: number | string;
    quantity?: number;
    item_price?: number;
}

export interface ConversionEvent {
    data: ConversionApiEventType[];
    test_event_code?: string;
}
